import { EditText } from '../../../../../../component/ui/edit-text/edit-text';
import { EditNumber } from '../../../../../../component/ui/edit-text/edit-number';
import { Button } from 'primereact/button';
import React, { useState } from 'react';
import { updateAbstractCourseNameOperation } from '../operations/update-abstract-course-name-operation';

interface UpdateNewAbstractCourseDialogDataModel {
  onHide: () => any;
  abstractCourseId: number | undefined;
  name: string | undefined;
  courseHours: number | undefined;
  coursePercentage: number | undefined;
}
export const UpdateNewAbstractCourseDialog: React.FC<
  UpdateNewAbstractCourseDialogDataModel
> = ({ onHide, abstractCourseId, name, courseHours, coursePercentage }) => {
  const [courseName, setCourseName] = useState(name);
  const [hoursNumber, setHoursNumber] = useState(courseHours);
  const [percentage, setPercentage] = useState(coursePercentage);
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    await updateAbstractCourseNameOperation(
      abstractCourseId,
      courseName,
      hoursNumber,
      percentage,
      setLoading,
      onHide,
    );
  };

  return (
    <div>
      <EditText title={'שם'} value={courseName} onChange={setCourseName} />

      <EditNumber
        title={'כמות שעות'}
        value={hoursNumber}
        onChange={setHoursNumber}
      />

      <EditNumber
        value={percentage}
        min={0}
        max={100}
        title={'אחוז נוכחות'}
        onChange={setPercentage}
      />

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button
          loading={loading}
          style={{ height: '30px' }}
          label={'שמירה'}
          onClick={onSubmit}
        />
      </div>
    </div>
  );
};
